// extracted by mini-css-extract-plugin
export default {"Loader":"UploadUserImgButton_Loader__4obMo"};